import { render } from "./MyResources.vue?vue&type=template&id=23752298"
import script from "./MyResources.vue?vue&type=script&lang=js"
export * from "./MyResources.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__